const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const convertToBoolean = require('../../../../helpers/convertToBoolean');

const TOOLTIP = 'A link to a website. The link will open in a new tab.';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);

    line1OfInputs.appendField('  Url:').appendField(new Blockly.FieldTextInput(), 'url');

    line1OfInputs
        .appendField('  Open in new Window:')
        .appendField(new Blockly.FieldCheckbox('true'), 'openInNewWindow');
}
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);

    addCodeProperties(['url', { key: 'openInNewWindow', handler: convertToBoolean }]);
    return code;
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
